import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  chapters: number;
  views: number;
  category: string;
  tags: string[];
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  status,
  chapters,
  views,
  tags,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          title={`${title} - 女神漫画`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
            status === 'completed'
              ? 'bg-accent-500 text-background-50'
              : 'bg-primary-500 text-background-50'
          }`}>
            {status === 'completed' ? '已完结' : '连载中'}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-xs text-background-50 font-medium">{rating}</span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-2 py-0.5 rounded-full bg-background-50/20 backdrop-blur-sm text-xs text-background-50">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">共{chapters}话</span>
          <span className="text-xs text-foreground-400">{formatViews(views)} 阅读</span>
        </div>
      </div>
    </Link>
  );
}